import moment from 'moment'

const MEETING_REQUEST_HEADERS = [
  'endUserId',
  'endUserName',
  'endUserEmail',
  'jobTitle',
  'companyName',
  'companyIndustry',
  'companySize',
  'companyLocation',
  'requestedOn',
]

const mapToRow = (meetingRequest, header) => {
  switch (header) {
    case 'endUserName':
      return meetingRequest.endUser.name
    case 'endUserEmail':
      return meetingRequest.endUser.email
    case 'jobTitle':
      return meetingRequest.endUser.title
    case 'companySize':
      return meetingRequest.companyEmployeesRange
    case 'companyLocation':
      return meetingRequest.companyCountry
    case 'requestedOn':
      return moment(meetingRequest.createdAt).toISOString()
    default:
      return meetingRequest[header]
  }
}

const sanitizeString = (str?: string) => {
  return typeof str === 'string' && str.includes(',') ? `"${str}"` : str
}

export const toCSV = (data) => {
  const response = [MEETING_REQUEST_HEADERS.join(',')]

  data.forEach((meeting) => {
    const row = MEETING_REQUEST_HEADERS.map((header) =>
      sanitizeString(mapToRow(meeting, header))
    )
    response.push(row.join(','))
  })
  return response.join('\n')
}
